/* eslint-disable import/prefer-default-export */
import { getRandomAndUniqueKey } from '../../utils/globalFunctions';
import { eventPendingAssignmentId, ubicationTypeEnum } from '../../utils/dataStatus';
import { stepEnum } from '../../components/CreateServiceRequest/Constants';
import { mapperAccountAssignmentObject } from '../../utils/mapper';

const deleteKeyIfIsEmptyArray = (array) =>
  array?.map((item) => {
    const currentItem = new Map(Object.entries(item));

    currentItem.forEach((value, key) => {
      if (Array.isArray(value) && !value.length) currentItem.delete(key);
    });

    return Object.fromEntries(currentItem);
  });

const ProvidersMap = (providers) => {
  // Aca controlo que al menos se haya cargado el proveedor, porque si no genera un bug en la API
  if (!providers[0]?.provider?.id) return [];

  return providers?.map((provider) => ({
    idProveedor: provider?.provider?.id,
    idUnidadNegocio: provider?.businessUnit?.id,
    idContrato: provider?.contract?.id,
    numeroContrato: Number(provider?.contract?.nombre.split(' ')[0]) || undefined,
    tipoNotificacionEnum: provider?.notificate?.id,
    requiereAceptacion: provider?.contract?.requiereAceptacion,
    requiereAdjuntarArchivo: provider?.contract?.requiereAdjuntarArchivo
  }));
};

export const ApproversMap = (approvers) =>
  approvers?.map((approver) => ({
    id: approver?.id,
    idSolicitudServicioAprobadorDestinatario: approver?.idSolicitudServicioAprobador,
    idProveedor: approver?.idProveedor,
    nombre: approver?.nombre,
    esGrupo: approver?.esGrupo
  }));

const AditionlReceiversMap = (additionalReceivers) =>
  additionalReceivers?.map((receiver) => ({
    id: receiver?.id,
    idProveedor: receiver?.idProveedor,
    nombre: receiver?.nombre,
    esGrupo: receiver?.esGrupo
  }));

const serviceMap = (service, idSDS) => ({
  id: idSDS,
  idServicio: service.service?.id,
  servicioNombre: service.service?.nombre,
  fechaProbableRealizacion: service.probDate,
  fechaRespuesta: service.needDate,
  descripcion: service.description,
  prioridadEnum: service.priority?.id
});

const inspectorsAdapter = (inspectors) =>
  inspectors?.map((inspector) => ({
    idSolicitudServicioInspector: inspector?.idSolicitudServicioInspector,
    idInspector: inspector?.id,
    nombre: inspector?.nombre,
    esGrupo: inspector?.esGrupo
  }));

const technicalLocationAdapter = ({ imputationObject, isOyM, ubication }) => {
  if (!isOyM) return {};

  const { ubicationType, uunn: operation, installation, ubication: technicalLocation } = ubication;

  return {
    eventoNombre: ubicationType?.tipoNegocio?.evento?.nombre,
    eventoSigla: ubicationType?.tipoNegocio?.evento?.sigla,
    idEvento: ubicationType?.tipoNegocio?.evento?.id,
    ubicacionTecnica: {
      idUbicacion: technicalLocation.id,
      codigoSapUbicacion: technicalLocation.codigoSAP,
      idOperacion: operation.id,
      codigoSapOperacion: operation.codigoSAP,
      descripcionOperacion: operation.nombre,
      idInstalacion: installation?.id,
      instalacionNombre: installation?.nombre,
      codigoSapInstalacion: installation?.codigoSAP,
      tipoImputacionEnum: imputationObject?.wells[0]?.imputationType?.value,
      idObjetoImputacion: imputationObject?.wells[0]?.imputationObject?.value,
      idClasificacion: ubication.classification?.id,
      clasificacionNombre: ubication.classification?.nombre
    }
  };
};

const ubicationAdapter = ({ imputationObject, isOyM, ubication }) => {
  if (isOyM)
    return {
      unidadNegocioNombre: '',
      idEvento: 30,
      eventoNombre: 'OyM',
      eventoSigla: 'OyM'
    };
  let wells = [];

  wells = imputationObject?.wells?.map((well) => ({
    idPozo: well?.well?.id || well?.well?.value,
    idEquipo: well?.team?.value,
    tipoImputacionEnum: well?.imputationType?.value || 0,
    idObjetoImputacion: well?.imputationObject?.value || 0,
    idEventoPozo: well?.event?.eventoPozoId || 0,
    eliminado: well?.eliminado
  }));

  if (
    ubication?.event?.id === eventPendingAssignmentId &&
    ubication.ubicationType?.id === ubicationTypeEnum.pozo
  ) {
    wells = [
      {
        idPozo: ubication?.ubication?.id,
        idEquipo: ubication?.team?.id,
        tipoImputacionEnum: 0,
        idObjetoImputacion: 0,
        idEventoPozo: 0,
        eliminado: false
      }
    ];
  }

  return {
    idUnidadNegocio: ubication?.uunn?.id,
    unidadNegocioNombre: ubication?.uunn?.nombre,
    idEvento:
      ubication?.event?.id ||
      imputationObject?.wells[0]?.event?.id ||
      imputationObject?.wells[0]?.operationType?.id,
    eventoNombre:
      ubication?.event?.nombre ||
      imputationObject?.wells[0]?.event?.nombre ||
      imputationObject?.wells[0]?.operationType?.nombre,
    eventoSigla:
      ubication?.event?.sigla ||
      imputationObject?.wells[0]?.event?.sigla ||
      imputationObject?.wells[0]?.operationType?.sigla,
    pozos: wells
  };
};

export const createMultipleServiceRequestAdapter = (
  params,
  deletedServices = [],
  idSDSToReply,
  isApplyTemplateRequest = false
) => {
  const ubication = ubicationAdapter(params);

  const technicalLocation = technicalLocationAdapter(params);

  const services = params?.accordions?.map((accordion) => ({
    ...serviceMap(accordion?.service, idSDSToReply ? null : accordion.serviceRequestId),
    stepEnum: accordion?.accordionStep,
    proveedores: ProvidersMap(accordion?.provider.providers),
    aprobadores: ApproversMap(accordion?.associatedUsers?.approvers),
    destinatarios: AditionlReceiversMap(accordion?.associatedUsers?.aditionalReceivers),
    inspectores: inspectorsAdapter(accordion?.associatedUsers?.inspectors)
  }));

  return {
    guardar: params?.stateSave,
    ubicacion: {
      tipoUbicacionEnum: params?.ubication?.ubicationType?.id,
      ubicacionNombre: params.isOyM
        ? params.ubication?.ubication?.nombre
        : `${params.ubication?.ubication?.nombre} ${
            params.ubication?.event?.sigla ||
            params.imputationObject.wells[0]?.event?.sigla ||
            params?.ubication?.operationType?.sigla ||
            ''
          } ${params.ubication?.team?.label || params.imputationObject.wells[0]?.team?.label}`,
      ...ubication,
      ...technicalLocation,
      eventoSigla: params?.ubication?.operationType?.sigla || ubication?.eventoSigla,
      idEvento: params?.ubication?.operationType?.id || ubication?.idEvento
    },
    servicios: isApplyTemplateRequest
      ? [...deleteKeyIfIsEmptyArray(services)]
      : [...deleteKeyIfIsEmptyArray(services), ...deletedServices]
  };
};

const providersMapper = (providers) =>
  providers?.map((provider) => ({
    idRequestProvider: provider?.idSolicitudServicioProveedor,
    provider: {
      value: provider?.proveedor?.id,
      id: provider?.proveedor?.id,
      nombre: provider?.proveedor?.nombre,
      label: provider?.proveedor?.nombre
    },
    businessUnit: {
      id: provider?.unidadNegocio?.id,
      value: provider?.unidadNegocio?.id,
      nombre: provider?.unidadNegocio?.nombre,
      label: provider?.unidadNegocio?.nombre
    },
    contract: {
      id: provider?.contrato?.id,
      nombre: provider?.contrato?.nombre,
      value: provider?.contrato?.id,
      label: provider?.contrato?.nombre,
      requiereAceptacion: provider?.requiereAceptacion,
      requiereAdjuntarArchivo: provider?.requiereAdjuntarArchivo
    },
    alert: {
      alert: provider?.alertasPorContrato?.alerta,
      availableAmount: provider?.alertasPorContrato?.montoDisponible,
      message: provider?.alertasPorContrato?.mensajes
    },
    notificate: {
      id: provider?.tipoNotificacion?.id,
      nombre: provider?.tipoNotificacion?.nombre,
      value: provider?.tipoNotificacion?.id,
      label: provider?.tipoNotificacion?.nombre
    }
  }));

const approversMapper = (approvers) =>
  approvers?.map((approver) => ({
    id: approver?.id,
    value: approver?.id,
    nombre: approver?.nombre,
    label: approver?.nombre,
    esGrupo: approver?.esGrupo,
    idRequestApprover: approver?.idSolicitudServicioAprobador
  }));

const aditionalReceiversMapper = (aditionalReceivers) =>
  aditionalReceivers?.map((aditionalReceiver) => ({
    id: aditionalReceiver?.id,
    value: aditionalReceiver?.id,
    nombre: aditionalReceiver?.nombre,
    label: aditionalReceiver?.nombre,
    esGrupo: aditionalReceiver?.esGrupo,
    idProveedor: aditionalReceiver?.idProveedor,
    idRequestAditionalReceivers: aditionalReceiver?.idSolicitudServicioDestinatario
  }));

const receiversMapper = (receivers) =>
  receivers?.map((receiver) => ({
    idProveedor: receiver?.proveedorId,
    id: receiver?.id,
    nombre: receiver?.nombre,
    esGrupo: receiver?.esGrupo,
    idRequestAditionalReceivers: receiver?.idSolicitudServicioDestinatario
  }));

const attachmentsMapper = (attachments, accordionId, serviceRequestId) =>
  attachments?.map((attachment) => ({
    id: attachment?.id || attachment?.nombre,
    nombre: attachment?.nombre,
    peso: attachment?.peso,
    fechaSubida: attachment?.fechaSubida,
    usuarioSubida: attachment?.usuarioSubida,
    accordionId,
    serviceRequestId
  }));

const accordionsMapper = (
  accordions,
  isReplyRequest = false,
  isEditTemplate = false,
  isApplyTemplateRequest = false,
  isDraw = false
) =>
  accordions?.map((accordion) => {
    const uniqueKey = getRandomAndUniqueKey();

    return {
      accordionId: uniqueKey,
      accordionStep: accordion?.stepEnum,
      serviceRequestId: accordion?.idSolicitudServicio,
      templeteRequestId: accordion?.idPlantillaSolicitudServicio,
      serviceRequestNumber: accordion?.numero,
      service: accordion.servicio?.servicio?.id
        ? {
            service: {
              id: accordion.servicio?.servicio?.id,
              nombre: accordion.servicio?.servicio?.nombre,
              value: accordion.servicio?.servicio?.id,
              label: accordion.servicio?.servicio?.nombre
            },
            probDate:
              isReplyRequest || isEditTemplate || isDraw || isApplyTemplateRequest
                ? undefined
                : accordion.servicio?.fechaProbableRealizacion,
            needDate:
              isReplyRequest || isEditTemplate || isDraw || isApplyTemplateRequest
                ? undefined
                : accordion.servicio?.fechaRespuesta,
            priority:
              isReplyRequest || isEditTemplate || isDraw || isApplyTemplateRequest
                ? undefined
                : {
                    id: accordion?.servicio?.prioridad?.id,
                    nombre:
                      accordion?.servicio?.prioridad?.nombre?.split(' ')[1]?.replace(':', '') || '',
                    label:
                      accordion?.servicio?.prioridad?.nombre?.split(' ')[1]?.replace(':', '') || '',
                    value: accordion?.servicio?.prioridad?.id
                  },
            description: accordion.servicio?.descripcion
          }
        : {
            service: null,
            probDate: '',
            needDate: '',
            priority: null,
            description: ''
          },
      provider: {
        providers: providersMapper(accordion.proveedores)
      },
      associatedUsers: {
        approvers: approversMapper(accordion.aprobadores),
        aditionalReceivers: aditionalReceiversMapper(accordion.destinatarios),
        receivers: receiversMapper(accordion.destinatariosDefault)
      },
      attachments: attachmentsMapper(
        accordion.archivosAdjuntos?.activos,
        uniqueKey,
        accordion?.idSolicitudServicio
      )
    };
  });

const getCurrentStepEnum = (draftResponse) =>
  draftResponse.solicitudes?.some((service) => service?.numero)
    ? stepEnum.services
    : stepEnum.ubication;

const mapperUbication = (
  isEditTemplate,
  isReplyRequest,
  isApplyTemplateRequest,
  isOyM,
  ubication
) => {
  if (isApplyTemplateRequest) {
    return null;
  }
  if (isOyM) {
    return ubication?.ubicacionTecnica?.ubicacion?.id
      ? {
          id: ubication?.ubicacionTecnica?.ubicacion?.id,
          nombre: ubication?.ubicacionTecnica?.ubicacion?.descripcion,
          value: ubication?.ubicacionTecnica?.ubicacion?.id,
          label: ubication?.ubicacionTecnica?.ubicacion?.descripcion,
          codigoSAP: ubication?.ubicacionTecnica?.ubicacion.codigo
        }
      : undefined;
  }

  return ubication?.locacion?.id || ubication?.pozos[0]?.pozo?.id
    ? {
        id:
          ubication?.tipoUbicacion?.id === ubicationTypeEnum.locacion
            ? ubication.locacion.id
            : ubication?.pozos[0]?.pozo?.id,
        nombre:
          ubication?.tipoUbicacion?.id === ubicationTypeEnum.locacion
            ? ubication.locacion.nombre
            : ubication?.pozos[0]?.pozo?.nombre,
        value:
          ubication?.tipoUbicacion?.id === ubicationTypeEnum.locacion
            ? ubication.locacion.id
            : ubication?.pozos[0]?.pozo?.id,
        label:
          ubication?.tipoUbicacion?.id === ubicationTypeEnum.locacion
            ? ubication.locacion.nombre
            : ubication?.pozos[0]?.pozo?.nombre
      }
    : undefined;
};

export const draftResponseAdapter = (
  draftResponse,
  presupuesto = [],
  isReplyRequest = false,
  isEditTemplate = false,
  isDraw = false,
  isApplyTemplateRequest = false,
  isOyM = false
) => ({
  isTemplate: isDraw || isEditTemplate,
  templateName: draftResponse?.nombrePlantilla,
  templateIsPublic: draftResponse?.esPublico,
  changeDependencieApprover: 0,
  gsdsNumber: isReplyRequest || isEditTemplate || isDraw ? undefined : draftResponse?.numeroGSDS,
  currentStep: isReplyRequest || isEditTemplate || isDraw ? 1 : getCurrentStepEnum(draftResponse),
  isOyM,
  ubication: {
    currentStepUbication: 1,
    ubicationType: {
      id: draftResponse?.ubicacion?.tipoUbicacion?.id,
      nombre: draftResponse?.ubicacion?.tipoUbicacion?.nombre,
      value: draftResponse?.ubicacion?.tipoUbicacion?.id,
      label: draftResponse?.ubicacion?.tipoUbicacion?.nombre,
      // Esta key es para el caso de que el borrador sea OyM
      tipoNegocio: {
        evento: {
          id: draftResponse?.ubicacion?.evento?.id,
          nombre: draftResponse?.ubicacion?.evento?.nombre,
          sigla: draftResponse?.ubicacion?.evento?.sigla,
          value: draftResponse?.ubicacion?.evento?.id
        }
      }
    },
    uunn: isOyM
      ? {
          id: draftResponse?.ubicacion?.ubicacionTecnica?.operacion?.id,
          nombre: draftResponse?.ubicacion?.ubicacionTecnica?.operacion?.descripcion,
          value: draftResponse?.ubicacion?.ubicacionTecnica?.operacion?.id,
          label: draftResponse?.ubicacion?.ubicacionTecnica?.operacion?.descripcion
        }
      : {
          id: draftResponse?.ubicacion?.unidadNegocio?.id,
          nombre: draftResponse?.ubicacion?.unidadNegocio?.nombre,
          value: draftResponse?.ubicacion?.unidadNegocio?.id,
          label: draftResponse?.ubicacion?.unidadNegocio?.nombre
        },
    ubication: mapperUbication(
      isEditTemplate,
      isReplyRequest,
      isApplyTemplateRequest,
      isOyM,
      draftResponse?.ubicacion
    ),
    event: draftResponse?.ubicacion?.evento?.id
      ? {
          id: draftResponse?.ubicacion?.evento?.id,
          nombre: draftResponse?.ubicacion?.evento?.nombre,
          sigla: draftResponse?.ubicacion?.evento?.sigla,
          value: draftResponse?.ubicacion?.evento?.id,
          label: draftResponse?.ubicacion?.evento?.nombre,
          eventoPozoId:
            draftResponse?.ubicacion?.pozos[0]?.idEventoPozo ||
            draftResponse?.ubicacion?.evento?.eventoPozoId
        }
      : undefined,
    typeEvent: draftResponse?.ubicacion?.evento
      ? {
          id: draftResponse?.ubicacion?.evento?.id,
          nombre: draftResponse?.ubicacion?.evento?.sigla,
          value: draftResponse?.ubicacion?.evento?.id,
          label: draftResponse?.ubicacion?.evento?.sigla
        }
      : null,
    operationType: draftResponse?.ubicacion?.evento
      ? {
          id: draftResponse?.ubicacion?.evento?.id,
          nombre: draftResponse?.ubicacion?.evento?.sigla,
          value: draftResponse?.ubicacion?.evento?.id,
          label: draftResponse?.ubicacion?.evento?.sigla
        }
      : null,
    team: draftResponse?.ubicacion?.pozos[0]?.equipo?.id
      ? {
          id: draftResponse?.ubicacion?.pozos[0]?.equipo?.id,
          nombre: draftResponse?.ubicacion?.pozos[0]?.equipo?.nombre,
          value: draftResponse?.ubicacion?.pozos[0]?.equipo?.id,
          label: draftResponse?.ubicacion?.pozos[0]?.equipo?.nombre
        }
      : undefined,
    installation: draftResponse?.ubicacion?.ubicacionTecnica?.instalacion?.id
      ? {
          id: draftResponse?.ubicacion?.ubicacionTecnica?.instalacion?.id,
          nombre: draftResponse?.ubicacion?.ubicacionTecnica?.instalacion?.descripcion,
          value: draftResponse?.ubicacion?.ubicacionTecnica?.instalacion?.id,
          label: draftResponse?.ubicacion?.ubicacionTecnica?.instalacion?.descripcion
        }
      : undefined,
    classification: draftResponse?.ubicacion?.ubicacionTecnica?.clasificacion?.id
      ? {
          id: draftResponse?.ubicacion?.ubicacionTecnica?.clasificacion?.id,
          nombre: draftResponse?.ubicacion?.ubicacionTecnica?.clasificacion?.descripcion,
          value: draftResponse?.ubicacion?.ubicacionTecnica?.clasificacion?.id,
          label: draftResponse?.ubicacion?.ubicacionTecnica?.clasificacion?.descripcion
        }
      : undefined
  },
  imputationObject: {
    wells: isApplyTemplateRequest
      ? []
      : mapperAccountAssignmentObject({
          wells: draftResponse?.ubicacion.pozos,
          budget: presupuesto,
          event: draftResponse?.ubicacion.evento,
          eventPendingOfAssignment: draftResponse?.ubicacion.pozos[0]?.objetoImputacion?.id === 0,
          isOyM,
          technicalLocation: draftResponse?.ubicacion.ubicacionTecnica
        }),
    wellsCopy: isApplyTemplateRequest
      ? []
      : mapperAccountAssignmentObject({
          wells: draftResponse?.ubicacion.pozos,
          budget: presupuesto,
          event: draftResponse?.ubicacion.evento,
          eventPendingOfAssignment: draftResponse?.ubicacion.pozos[0]?.objetoImputacion?.id === 0,
          isOyM,
          technicalLocation: draftResponse?.ubicacion.ubicacionTecnica
        })
  },
  accordions: accordionsMapper(
    draftResponse?.solicitudes,
    isReplyRequest,
    isEditTemplate,
    isApplyTemplateRequest,
    isDraw
  )
});
